export default "/images/2c45d2f2c759422c935fac04d7189ae1.avif";